import React, {Component} from 'react';
import Collapsible from 'react-collapsible';
import QuestionHead from './QuestionHead';
import QuestionContent from './QuestionContent.jsx';

export default class extends Component {
  render() {
    const data = [
      {
        label: 'QUESTION 1',
        caption: 'Written Assignment',
        questionType: 'wrong'
      },
      {
        label: 'QUESTION 2',
        caption: 'Written Assignment',
        questionType: 'waite'
      },
      {
        label: 'QUESTION 3',
        caption: 'Written Assignment',
        questionType: 'completed'
      }
    ];

    const questionList = (item, index) => {

      const questionHeader = (
        <QuestionHead
          label={item.label}
          caption={item.caption}
          questionType={item.questionType}/>
      );

      return (
        <Collapsible
          className="question-accordion-item"
          openedClassName="question-accordion-item is-active"
          trigger={questionHeader}
          key={index}>
          <QuestionContent/>
        </Collapsible>
      )
    };

    return (<div className="question-accordion-inner">
        {data.map((item, index) => {
          return questionList(item, index)
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/questions/QuestionContainer.jsx